import React from 'react'
import { format } from 'date-fns'
import {
  Badge,
  Box,
  Button,
  Checkbox,
  Divider,
  HStack,
  Stack,
  Text,
  Textarea
} from '@chakra-ui/react'

import { Eviction } from './Grid'

interface EvictionSidepeekNotesTabProps {
  eviction: Eviction | null
  canManageEvictions: boolean
  newNote: string
  isAddingNote: boolean
  isConsentJudgementNote: boolean
  onNewNoteChange: (value: string) => void
  onConsentJudgementNoteChange: (value: boolean) => void
  onAddNote: () => void
}

const EvictionSidepeekNotesTab: React.FC<EvictionSidepeekNotesTabProps> = ({
  eviction,
  canManageEvictions,
  newNote,
  isAddingNote,
  isConsentJudgementNote,
  onNewNoteChange,
  onConsentJudgementNoteChange,
  onAddNote
}) => {
  const trimmedNewNote = newNote.trim()

  return (
    <Stack spacing={3}>
      <Stack spacing={2}>
        <Textarea
          placeholder='Add a note...'
          value={newNote}
          isDisabled={!canManageEvictions}
          onChange={(e) => onNewNoteChange(e.target.value)}
          rows={3}
        />
        <HStack justify='space-between'>
          <Checkbox
            size='sm'
            isDisabled={!canManageEvictions}
            isChecked={isConsentJudgementNote}
            onChange={(e) => onConsentJudgementNoteChange(e.target.checked)}
          >
            Consent Judgement note
          </Checkbox>
          <Button
            colorScheme='teal'
            variant='outline'
            size='xs'
            onClick={onAddNote}
            isDisabled={!canManageEvictions || !trimmedNewNote || isAddingNote}
            isLoading={isAddingNote}
          >
            Add Note
          </Button>
        </HStack>
      </Stack>

      <Divider />

      {(!eviction?.rental?.notes || eviction.rental.notes.length === 0) && (
        <Text color='gray.500' fontSize='sm'>
          No notes yet
        </Text>
      )}

      {eviction?.rental?.notes?.map((note) => (
        <Box key={note.id} p={3} bg='gray.50' borderRadius='md'>
          <HStack>
            <Text fontSize='sm' color='gray.500'>
              {format(new Date(note.created_at), 'MM/dd/yyyy')}
              {note.admin && ` - ${note.admin.first_name} ${note.admin.last_name}`}
            </Text>
            {note.category === 'consent_judgement' && (
              <Badge colorScheme='purple' fontSize='xs'>
                Consent Judgement
              </Badge>
            )}
          </HStack>
          <Text mt={1}>{note.note}</Text>
        </Box>
      ))}
    </Stack>
  )
}

export default EvictionSidepeekNotesTab
